import { ref } from 'vue';
import { removeLuggage } from '@/features/application/removeLuggage/api/removeLuggage';

/**
 * 荷物削除のカスタムフック
 * @returns 荷物削除関連の状態と関数
 */
export const useRemoveLuggage = () => {
    const isLoading = ref(false);
    const errorMessage = ref<string>('');
    const successMessage = ref<string>('');

    /**
     * 荷物を削除する
     * @param applicationId - 申し込みID
     * @param luggageQrCode - 荷物QRコード
     * @returns 成功時はtrue、失敗時はfalse
     */
    const removeLuggageFromApplication = async (applicationId: string, luggageQrCode: string): Promise<boolean> => {
        try {
            isLoading.value = true;
            errorMessage.value = '';
            successMessage.value = '';

            await removeLuggage(applicationId, luggageQrCode);

            successMessage.value = '荷物を正常に削除しました。';
            return true;
        } catch (error) {
            errorMessage.value = (error as Error).message;
            return false;
        } finally {
            isLoading.value = false;
        }
    };

    /**
     * エラーメッセージをクリアする
     */
    const clearError = () => {
        errorMessage.value = '';
    };

    /**
     * 成功メッセージをクリアする
     */
    const clearSuccess = () => {
        successMessage.value = '';
    };

    /**
     * すべてのメッセージをクリアする
     */
    const clearMessages = () => {
        errorMessage.value = '';
        successMessage.value = '';
    };

    return {
        isLoading,
        errorMessage,
        successMessage,
        removeLuggageFromApplication,
        clearError,
        clearSuccess,
        clearMessages,
    };
};
